module.exports = __webpack_public_path__ + "static/media/dicom-icon.6d2ffea8.svg";


//////////////////
// WEBPACK FOOTER
// ./public/dicom-icon.svg
// module id = 237
// module chunks = 3